import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Error, LoadingSpinner } from '../../components'
import auth0, { getBrowseRedirectUri } from '../../utils/auth0'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'
import { getOptionalEmailVerificationEnabled } from '../../utils/monetate'

type Props = {
  initialScreen?: 'login' | 'registration' | 'request_reset_password'
}

export default function BrowseLogin({ initialScreen: screen }: Props): JSX.Element {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<{ code: string } | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        const initialScreen = screen || searchParams.get('initialScreen')
        const email = initialScreen === 'request_reset_password' ? searchParams.get('email') : null
        const forceEmailVerification = searchParams.get('force_ev') === 'true'
        const redirectUri = getBrowseRedirectUri(searchParams)
        const optionalEmailVerificationEnabled = await getOptionalEmailVerificationEnabled()
        await auth0().loginWithRedirect({
          authorizationParams: {
            redirect_uri: redirectUri,
            newSignUpFlow: true,
            ...(email && { email }),
            ...(initialScreen && { initialScreen }),
            ...(forceEmailVerification && { force_ev: forceEmailVerification }),
            ...(optionalEmailVerificationEnabled && { optional_ev: true }),
          },
        })
      } catch (error) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-login', error)
        setError({ code: 'browse.login.error' })
      }
    })()
  }, [])

  return <div data-testid="browse-login">{error ? <Error /> : <LoadingSpinner />}</div>
}
